import axios from 'axios'
// import VueCookie from 'vue-cookie'
import _localStorage from './local_storage'

const api = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    common: {
      'Authorization': `Bearer ${_localStorage.get(process.env.VUE_APP_TOKEN)}`
    }
  }
})

export { api }
